import { checkForNaN } from 'GenericForms/Helper';
import React from 'react';
import { Label } from 'reactstrap';
import { VesselFuelType } from 'ReportingWizard/EngineerReport/partials/EngineerReportingTypes';

interface FuelTypeROBdetailsTableType {
    fuelType: VesselFuelType,
    FuelConsumptionSum: any,
    FuelBatchAdjustmentSum: number,
    totalBunkering: { [key: number]: number },
    totalDebunkering: { [key: number]: number },
    PreviousFuelTypeROB: { [key: string]: string | number | boolean | Date | null }[]
}

const FuelTypeROBDetailsTable = ({
    fuelType,
    FuelConsumptionSum,
    FuelBatchAdjustmentSum,
    totalBunkering,
    totalDebunkering,
    PreviousFuelTypeROB
}: FuelTypeROBdetailsTableType) => {
    const Debunkering = totalDebunkering && (totalDebunkering[fuelType?.fuel_type] ?? 0);

    // Get ROB before value safely
    const robBefore = PreviousFuelTypeROB?.filter(
        (item: { [key: string]: string | number | boolean | Date | null }) =>
            item.fuel_type_precedence_id === fuelType.fuel_type_precedence_id
    )[0]?.rob as number || 0;

    // Use the existing checkForNaN helper consistently for formatting
    const formatNumber = (value: any, decimals: number = 4): string => {
        return checkForNaN(value, decimals).toFixed(decimals);
    };

    // Calculate ROB after once to avoid repeated computation
    const robAfter = checkForNaN(robBefore, 4) +
        checkForNaN(totalBunkering?.[fuelType?.fuel_type] ?? 0, 4) -
        checkForNaN(totalDebunkering?.[fuelType?.fuel_type] ?? 0, 4) -
        checkForNaN(FuelConsumptionSum, 4) +
        checkForNaN(FuelBatchAdjustmentSum, 4);

    return (
        <table className='width-100 p-0 m-0'>
            <thead>
                <tr>
                    <th>{fuelType.fuel_type_name}(mt)</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><Label className='small-unit-size mb-0 w-7'>ROB(before):&nbsp;</Label></td>
                    <td className='text-right'>
                        <b className="small-unit-size color-green">{formatNumber(robBefore)}</b>
                    </td>
                </tr>
                <tr>
                    <td><Label className='small-unit-size mb-0 w-7'>Bunkered Qty:&nbsp;</Label></td>
                    <td className='text-right'>
                        <b className="small-unit-size color-green">{formatNumber(totalBunkering?.[fuelType?.fuel_type] ?? 0)}</b>
                    </td>
                </tr>
                <tr>
                    <td><Label className='small-unit-size mb-0 w-7'>Debunkered Qty:&nbsp;</Label></td>
                    <td className='text-right'>
                        <b className={`small-unit-size ${checkForNaN(Debunkering, 4) === 0 ? "color-green" : "color-red"}`}>
                            {`${checkForNaN(Debunkering, 4) > 0 ? "-" : ""}${formatNumber(Debunkering)}`}
                        </b>
                    </td>
                </tr>
                <tr>
                    <td><Label className='small-unit-size mb-0 w-7'>Consumption:</Label></td>
                    <td className='text-right'>
                        <b className={`small-unit-size ${checkForNaN(FuelConsumptionSum, 4) === 0 ? "color-green" : "color-red"}`}>
                            {`${checkForNaN(FuelConsumptionSum, 4) > 0 ? "-" : ""}${formatNumber(FuelConsumptionSum)}`}
                        </b>
                    </td>
                </tr>
                <tr>
                    <td><Label className='small-unit-size mb-0 w-7'>Adjustments:&nbsp;</Label></td>
                    <td className='text-right'>
                        <b className={`small-unit-size ${checkForNaN(FuelBatchAdjustmentSum, 4) >= 0 ? 'color-green' : 'color-red'}`}>
                            {formatNumber(FuelBatchAdjustmentSum)}
                        </b><br />
                    </td>
                </tr>
                <tr>
                    <td><Label className='small-unit-size mb-0 w-7'>ROB(after):&nbsp;</Label></td>
                    <td className='text-right'>
                        <b className="small-unit-size">
                            {formatNumber(robAfter)}
                        </b>
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

export default FuelTypeROBDetailsTable